(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pom-duo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cups = { 4: '¼ cup', 8: '½ cup', 12: '¾ cup', 16: '1 cup' };
  function init() {
    document.querySelectorAll('[data-pom-recipe]').forEach(function (box) {
      if (box.dataset.pomReady) return;
      box.dataset.pomReady = '1';
      var btns = box.querySelectorAll('.cpp-serv button');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var f = +b.dataset.s / 2;
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          box.querySelectorAll('.cpp-ing b').forEach(function (el) {
            var n = +el.dataset.base * f, u = el.dataset.unit;
            if (u === 'tbsp' && cups[n]) el.textContent = cups[n];
            else el.textContent = n + ' ' + (n > 1 && plural[u] ? plural[u] : u);
          });
        });
      });
    });
    // "Add both" button: add the two products with Shopify's cart API, then open the cart
    document.querySelectorAll('form[data-pom-multi]').forEach(function (form) {
      if (form.dataset.pomReady) return;
      form.dataset.pomReady = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = JSON.parse(form.dataset.pomMulti);
        var btn = form.querySelector('button');
        btn.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          btn.disabled = false;
          // Ask the theme (Impulse) to refresh and open its side cart
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          // If no side cart opened, fall back to the cart page
          setTimeout(function () {
            var drawer = document.querySelector('#CartDrawer, .drawer--right, cart-drawer');
            var open = drawer && (drawer.classList.contains('drawer--is-open') || drawer.hasAttribute('open') || drawer.classList.contains('active'));
            if (!open && !document.documentElement.classList.contains('js-drawer-open')) window.location.href = '/cart';
          }, 900);
        }).catch(function () {
          btn.disabled = false;
          form.submit();
        });
      });
    });
  }
  var plural = { pinch: 'pinches', clove: 'cloves' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pom-finalcta"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Add to cart with Shopify's cart API, then open the theme's side cart
  function init() {
    document.querySelectorAll('form[data-pom-multi]').forEach(function (form) {
      if (form.dataset.pomReady) return;
      form.dataset.pomReady = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        btn.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: JSON.parse(form.dataset.pomMulti) })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          btn.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          setTimeout(function () {
            var drawer = document.querySelector('#CartDrawer, .drawer--right, cart-drawer');
            var open = drawer && (drawer.classList.contains('drawer--is-open') || drawer.hasAttribute('open') || drawer.classList.contains('active'));
            if (!open && !document.documentElement.classList.contains('js-drawer-open')) window.location.href = '/cart';
          }, 900);
        }).catch(function () {
          btn.disabled = false;
          form.submit();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pom-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(c) { return '$' + (c / 100).toFixed(2); }

  function initBuy(form) {
    if (form.dataset.pomReady) return;
    form.dataset.pomReady = '1';
    var qty = form.querySelector('[name="quantity"]');
    var sub = form.querySelector('[data-plan="sub"]');
    var sel = form.querySelector('[data-plan-select]');
    var total = form.querySelector('[data-pom-total]');
    var ship = form.querySelector('[data-pom-ship]');
    var once = +form.dataset.price, subp = +form.dataset.subPrice, free = +form.dataset.free;

    function q() { var n = parseInt(qty.value, 10); return isNaN(n) || n < 1 ? 1 : Math.min(n, 99); }
    function refresh() {
      var isSub = sub && sub.checked;
      // Only send selling_plan when Subscribe is chosen
      if (sel) { if (isSub) sel.setAttribute('name', 'selling_plan'); else sel.removeAttribute('name'); }
      var t = (isSub ? subp : once) * q();
      if (total) total.textContent = money(t);
      if (ship && free > 0) {
        var left = free - t;
        ship.innerHTML = left > 0
          ? form.dataset.shipTodo.replace('[amount]', '<b>' + money(left) + '</b>')
          : form.dataset.shipDone;
      }
    }
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(99, q() + (+b.dataset.qty))); refresh(); });
    });
    qty.addEventListener('input', refresh);
    form.querySelectorAll('[name="pom_plan"]').forEach(function (r) { r.addEventListener('change', refresh); });
    if (sel) sel.addEventListener('change', function () { sub.checked = true; refresh(); });
    refresh();
  }

  function initSticky() {
    var sticky = document.querySelector('[data-pom-sticky]');
    var buy = document.querySelector('[data-pom-buy]');
    if (!sticky || !buy || !('IntersectionObserver' in window)) return;
    var final = document.querySelector('.cpp-final');
    var buyVisible = true, finalVisible = false;
    function set() {
      var on = !buyVisible && !finalVisible;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.querySelector('button').tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0; set(); }).observe(buy);
    if (final) new IntersectionObserver(function (e) { finalVisible = e[0].isIntersecting; set(); }).observe(final);
  }

  function init() { document.querySelectorAll('[data-pom-buy]').forEach(initBuy); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
